import { render, staticRenderFns } from "./AdministrativePermitsBreadcrums.vue?vue&type=template&id=e61aeb7a"
import script from "./AdministrativePermitsBreadcrums.vue?vue&type=script&lang=js"
export * from "./AdministrativePermitsBreadcrums.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports